module.exports = __webpack_public_path__ + "img/cm_titleBg.acb2ad1c.png";